// extracted by mini-css-extract-plugin
export default {"upgradeText":"UpgradeOverlay_upgradeText__DYH9a"};